import { c as _c } from "react/compiler-runtime";
import { useIsMobile } from '@newfront-insurance/admin-ui';
import { cn } from '@newfront-insurance/core-ui/v2';
import { Settings } from 'lucide-react';
import { useChatOverlayContext } from '../contexts/chat-overlay-context';

/**
 * Composable notifications settings button component for navigator-nova chat sidebar.
 * Toggles settings panel in the main chat content area when clicked.
 * Styled to match sidebar menu items with cog icon and "Settings" text.
 *
 * This is similar to OutlookSettingsButton but only includes notifications,
 * not Outlook-specific settings.
 */
export function NotificationsSettingsButton() {
  const $ = _c(10);
  const {
    isSettingsOpen,
    setIsSettingsOpen,
    setIsSidebarOpen
  } = useChatOverlayContext();
  const {
    isMobile
  } = useIsMobile();
  let t0;
  if ($[0] !== isMobile || $[1] !== isSettingsOpen || $[2] !== setIsSettingsOpen || $[3] !== setIsSidebarOpen) {
    t0 = () => {
      setIsSettingsOpen(!isSettingsOpen);
      if (isMobile) {
        setIsSidebarOpen(false);
      }
    };
    $[0] = isMobile;
    $[1] = isSettingsOpen;
    $[2] = setIsSettingsOpen;
    $[3] = setIsSidebarOpen;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("text-muted-foreground flex w-full items-center gap-2 px-2 py-1.5 text-start", "hover:bg-steel-100 dark:hover:bg-steel-400 rounded-xs");
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex size-6 shrink-0 items-center justify-center"><Settings className="h-4 w-4" /></div>;
    t3 = <span>Settings</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t0) {
    t4 = <button type="button" onClick={t0} className={t1}>{t2}{t3}</button>;
    $[8] = t0;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}